
import request from '../request';
import qs from 'qs';
// 根据保险卡查询手机号
const queryMobileByCard = (data) => {
    return request.post(`/api/wx/auth/getMobileByCardNo?${qs.stringify(data)}`, data)
}
// 得到绑定卡的类型，保险公司，所在公司
const getCardInfo = (data) => {
    return request.post('/api/wx/auth/getCardInfo', data)
}
// 查询手机号绑定保险卡
const bindBxCardByMobile = (data) => {
    return request.post('/api/wx/auth/bindCardInfoBySms', data)
}
// 绑定保险卡
const bindBxCard = (data) => {
    return request.post('/api/wx/auth/bindCardInfo', data)
}
// 保存儿童保险卡
const addInsurceChildInfo = (data) => {
    return request.post('/api/wx/auth/addWxInsurceInfo', data)
}
// 获取保险人的子女关系
const getInsurceChildInfo = (data) => {
    return request.post('/api/wx/auth/getWxInsurceInfo', data)
}
// 解绑保险卡
const unbindCardInfo = (data) => {
    return request.post(`/api/wx/auth/unbindCardInfo?${qs.stringify(data)}`, data)
}
// 查询当前保险卡联系信息
const getEmployeePhone = (data) => {
    return request.post('/api/wx/auth/getEmployeePhone', data)
}
// 修改手机号和邮箱
const updateEmployeePhone = (data) => {
    return request.post('/api/wx/auth/updateEmployeePhone', data)
}
// 查询当前用户下系统上卡样
const getYlBackgroundInfoList = (data) => {
    return request.post('/api/wx/auth/getYlBackgroundInfoList', data)
}
// 绑定卡样
const bindYlBackgroundInfo = (data) => {
    return request.post('/api/wx/auth/bindYlBackgroundInfo', data)
}
// 保存卡样设置
const saveYlBackgroundInfo = (data) => {
    return request.post('/api/wx/auth/saveYlBackgroundInfo', data)
}
// 批量删除卡样
const batchDetailYlBackgroundInfo = (data) => {
    return request.post('/api/wx/auth/batchDetailYlBackgroundInfo', data)
}
// 客户申请实体卡
const applyEntryCard = (data) => {
    return request.post('/api/wx/auth/applyEntryCard', data)
}
// 查询申请记录接口
const getYlEntityCardInfoVo = (data) => {
    return request.post('/api/wx/auth/getYlEntityCardInfoVo', data)
}
// 补充上传资料
const uploadWxInsurceInfo = (data) => {
    return request.post('/api/wx/auth/uploadWxInsurceInfo', data)
}

// 对象数组
export default {
    queryMobileByCard,
    getCardInfo,
    bindBxCardByMobile,
    bindBxCard,
    addInsurceChildInfo,
    getInsurceChildInfo,
    unbindCardInfo,
    getEmployeePhone,
    updateEmployeePhone,
    getYlBackgroundInfoList,
    bindYlBackgroundInfo,
    saveYlBackgroundInfo,
    batchDetailYlBackgroundInfo,
    applyEntryCard,
    getYlEntityCardInfoVo,
    uploadWxInsurceInfo
};